import React from 'react';
import { Link } from 'react-router-dom';
import useText from '@/hooks/useText';
import { userAppContext } from '@/context/Context';
import { UserContext } from '@/types';
import { trackEvent } from '@/utils/analytics';

function HeroContent({ children }: { children?: React.ReactNode }) {
  const eyebrow = useText('home.hero.eyebrow');
  const title = useText('home.hero.title');
  const titleHighlight = useText('home.hero.title_highlight');
  const btnFreeTrial = useText('home.hero.btn_free_trial');
  const btnSeePlans = useText('home.hero.btn_view_plans');
  const { isAuthenticated } = (userAppContext() as UserContext) || {};

  return (
    <div className="home-hero-main">
      <div className="home-hero-top">
        <p className="home-hero-eyebrow">{eyebrow}</p>
        <h1 className="home-hero-title mb-4">
          {title}
          <span className="home-hero-highlight">{titleHighlight}</span>
        </h1>
        {!isAuthenticated && (
          <div className="home-hero-actions">
            <Link
              to="/free-trial-apply"
              className="home-hero-btn home-hero-btn-trial"
              onClick={() =>
                trackEvent({
                  name: 'navigation_click',
                  buttonId: 'home_free_trial',
                  label: 'Free Trial',
                  page: 'home',
                  section: 'hero',
                  feature: 'navigation',
                  eventCategory: 'navigation',
                })
              }
            >
              {btnFreeTrial}
            </Link>
            <Link
              to="/plans"
              className="home-hero-btn home-hero-btn-plans"
              onClick={() =>
                trackEvent({
                  name: 'navigation_click',
                  buttonId: 'home_see_plans',
                  label: 'See Plans',
                  page: 'home',
                  section: 'hero',
                  feature: 'navigation',
                  eventCategory: 'navigation',
                })
              }
            >
              {btnSeePlans}
            </Link>
          </div>
        )}
      </div>
      <div className="home-hero-center">{children}</div>
    </div>
  );
}

export default HeroContent;
